import React from 'react';
import LogoMarca from '../../images/Logo-2do-md-600px.svg';

const Logo = props => (
    <div>
        <img width={props.width} src={LogoMarca} title="Logomarca" />
    </div>
);

export default Logo;